import type { UserManagerSettings} from "oidc-client-ts";
import { WebStorageStateStore } from "oidc-client-ts";
// Dynamically determine redirect URIs based on current origin
const baseUrl = window.location.origin;
const loginPath = "/login";

//other client settings
export const oidcSettings: UserManagerSettings = {
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY!, 
  client_id: process.env.REACT_APP_CLIENT_ID!,            
  redirect_uri: `${baseUrl}${loginPath}`,                 
  silent_redirect_uri: `${baseUrl}/silent-check-sso`,
  post_logout_redirect_uri: `${baseUrl}${loginPath}`,   
  response_type: "code",
  scope: process.env.REACT_APP_SCOPE,
  automaticSilentRenew: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

// Viewer client settings 
export const viewerOidcSettings: UserManagerSettings = {
  authority: process.env.REACT_APP_KEYCLOAK_AUTHORITY!, 
  client_id: process.env.REACT_APP_SECOND_CLIENT_ID!,            
  redirect_uri: `${baseUrl}${loginPath}`,                 
  silent_redirect_uri: `${baseUrl}/silent-check-sso`,
  post_logout_redirect_uri: `${baseUrl}${loginPath}`,   
  response_type: "code",
  scope: process.env.REACT_APP_SCOPE,
  automaticSilentRenew: false,   
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
